import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { isEmpty } from 'lodash';
import Card from 'components/Card';
import DocumentsTable from 'components/DocumentsTable';
import DocumentsUpload from 'components/DocumentsUpload';
import dropStyles from 'dropzoneStyles.scss';
import cx from 'classnames';
import {
  getRole,
  getPosition,
  getEmployableId,
  getInstallerId,
  getDocumentUploadLoading,
  getDocumentUploadError,
  getPhaseDocuments,
} from '../../../../../../../reducers';
import {
  uploadDocument,
  updateDocument,
  fetchPhaseDocuments,
} from 'actionCreators';
import { can } from '../../../../../../../services';
import swal from 'sweetalert';
import isIfiPhase from '../../../phaseShow/components/ifiUtils';

class PhaseDocuments extends Component {
  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
    this.onDragEnter = this.onDragEnter.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onUploadCancel = this.onUploadCancel.bind(this);
    this.onSuccessUpload = this.onSuccessUpload.bind(this);
    this.state = {
      showDropHere: false,
      filesToUpload: [],
      activeFolders: [],
    };
  }

  componentWillMount = () => (!this.hasParentDocs() ? this.fetchDocs() : this.setFoldersOpen());

  onFolderOpen = (folderName) => {
    const { activeFolders } = this.state;
    if (activeFolders.indexOf(folderName) === -1) {
      activeFolders.push(folderName);
      this.setState({ activeFolders });
    }
  }

  onFolderClose = (folderName) => {
    const { activeFolders } = this.state;
    const folderIndex = activeFolders.indexOf(folderName);
    if (folderIndex > -1) {
      activeFolders.splice(folderIndex, 1);
      this.setState({ activeFolders });
    }
  }

  onDrop = files => this.setState({ showDropHere: false, filesToUpload: files });

  onDragEnter = () => this.setState({ showDropHere: true });

  onDragLeave = () => this.setState({ showDropHere: false });

  onSuccessUpload = (files) => {
    this.documentUpload(files)
    .then(this.fetchDocs())
    .then(() => this.setState({ filesToUpload: [] })).then(() => this.showSuccessAlert())
    .catch(() => { });
  }

  onUploadCancel = () => this.setState({ filesToUpload: [] });

  onNotUseTap = doc => this.props.updateDocument(
    doc.phase_id, { id: doc.id, not_use: !doc.not_use },
  );

  setFoldersOpen = () => this.setState({ activeFolders: Object
    .keys(this.props.documents)
    .filter(f => this.contractVerificationFilter(f) && !this.hideFloorPlanFolder(f)) });

  showSuccessAlert = () => (swal({
    title: 'Success!',
    text: 'Your file was successfully uploaded!',
    icon: 'success',
    buttons: false,
    timer: 3000,
  }));

  fetchDocs = () => this.props.fetchPhaseDocuments(this.props.phaseId)
    .then(() => this.setFoldersOpen());

  hasParentDocs = () => !isEmpty(this.props.parentDocs || {});

  contractVerificationFilter = folder => (!this.props.cv ||
    ['Floor Plan'].includes(folder))

  hideFloorPlanFolder = folder => (isIfiPhase({ source: this.props.source })
  && !this.props.cv)
  && ['Floor Plan'].includes(folder);

  documentUpload = formData => this.props.uploadDocument(formData, this.props.phaseId);

  render = () => {
    const {
      documents, uploadingDocuments, uploadError, role, canModifyDoc, cv, source, position,
      isDoingMeasure,
    } = this.props;
    const { showDropHere, filesToUpload, activeFolders } = this.state;
    const folderNames = Object.keys(documents).filter(f => this.contractVerificationFilter(f)
    && !this.hideFloorPlanFolder(f));
    const visibleDocuments = folderNames.reduce((acc, f) => {
      acc[f] = documents[f];
      return acc;
    }, {});
    const emptyDocs = (<div
      className={cx([dropStyles.placeholder], { [dropStyles.opaque]: showDropHere })}
    >
      <h4>It looks like you haven{'\''}t uploaded {cv ? 'a Floor Plan' : 'anything'}, yet!</h4>
      <h6>
        Drag your {cv ? 'Floor Plan file' : 'files'} into this box to upload.
        <span className={dropStyles.button}>Or click here</span>.
      </h6>
    </div>);
    const dropHere = (<div className={dropStyles.dropHere}>
      <h4>Drag your {cv ? 'Floor Plan file' : 'files'} into this area to upload them.</h4>
    </div>);
    return (<div className={dropStyles.whiteBack}>
      {showDropHere ? dropHere : null}
      <Dropzone
        onDrop={this.onDrop}
        onDragEnter={this.onDragEnter}
        onDragLeave={this.onDragLeave}
        className={cx([dropStyles.dropzone], { [dropStyles.empty]: folderNames.length === 0 })}
        disableClick={folderNames.length > 0}
      >
        {folderNames.length > 0 ? <Card
          className={cx([dropStyles.card], { [dropStyles.opaque]: showDropHere })}
        >
          <Dropzone className={dropStyles.uploadFile} onDrop={this.onDrop}>
            <p className={dropStyles.uploadText}>Upload a {cv ? 'Floor Plan' : 'file'}</p>
          </Dropzone>
          <DocumentsTable
            folders={visibleDocuments}
            onNotUseTap={this.onNotUseTap}
            activeFolders={activeFolders}
            onFolderOpen={this.onFolderOpen}
            onFolderClose={this.onFolderClose}
            canModifyDoc={canModifyDoc}
          />
        </Card> : emptyDocs}
      </Dropzone>
      {filesToUpload.length > 0 || uploadingDocuments ? <DocumentsUpload
        cv={cv}
        files={filesToUpload}
        onCancel={this.onUploadCancel}
        onSubmit={this.onSuccessUpload}
        uploadingDocuments={uploadingDocuments}
        uploadError={uploadError}
        role={role}
        source={source}
        position={position}
        isDoingMeasure={isDoingMeasure}
        fetchDocs={this.fetchDocs}
      /> : null}
    </div>);
  }
}

PhaseDocuments.defaultProps = { parentId: null, parentDocs: {}, cv: false };

PhaseDocuments.propTypes = {
  params: PropTypes.shape({
    id: PropTypes.string,
  }),
  cv: PropTypes.bool,
  phaseId: PropTypes.number,
  parentId: PropTypes.number,
  canEdit: PropTypes.bool,
  role: PropTypes.string,
  canModifyDoc: PropTypes.bool,
  parentDocs: PropTypes.object,
  documents: PropTypes.object,
  uploadError: PropTypes.string,
  uploadingDocuments: PropTypes.bool,
  uploadDocument: PropTypes.func.isRequired,
  updateDocument: PropTypes.func.isRequired,
  fetchPhaseDocuments: PropTypes.func.isRequired,
  source: PropTypes.string,
  position: PropTypes.string,
  isDoingMeasure: PropTypes.bool,
};

// An installer/crew is "doing the measure" on an IFI Assessment when they (or, for crew, their
// parent installer) are the assigned installer and no estimator has also been assigned -
// mirrors Ability#installer_assigned_ifi_role/crew_assigned_ifi_role's conditions. Installer
// users compare their own employable_id (which is the installer id); crew users compare their
// parent installer's id instead, since their own employable_id is a Crew id.
const isDoingMeasure = (state, role) => {
  const installerId = role === 'crew' ? getInstallerId(state) : getEmployableId(state);
  return ['installer', 'crew'].includes(role) &&
    state.phase.details.type === 'Assessment' &&
    state.phase.details.installer_id === installerId &&
    !state.phase.details.estimator_id;
};

const mapStateToProps = (state, ownProps) => {
  const role = getRole(state);
  return {
    canEdit: can(role, 'edit', 'phase'),
    canModifyDoc: can(role, 'edit', 'document'),
    role,
    phaseId: ownProps.parentId || ownProps.params.id,
    uploadingDocuments: getDocumentUploadLoading(state),
    uploadError: getDocumentUploadError(state),
    documents: !isEmpty(ownProps.parentDocs || {}) ?
      ownProps.parentDocs : getPhaseDocuments(state),
    source: state.phase.details.source,
    position: getPosition(state),
    isDoingMeasure: isDoingMeasure(state, role),
  };
};

export default connect(mapStateToProps, {
  uploadDocument,
  updateDocument,
  fetchPhaseDocuments,
})(PhaseDocuments);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseDocuments/index.jsx